/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   createMercator helper
 */

import SphericalMercator from '@mapbox/sphericalmercator'
import QuickLRU from 'quick-lru'

import { TILE_SIZE } from '../../constants'

const cache = new QuickLRU<number, SphericalMercator>({ maxSize: 10000 })

export const createMercator = (tileSize: number) => {
  const key = tileSize || TILE_SIZE

  if (!cache.has(key)) {
    cache.set(key, new SphericalMercator({ size: key }))
  }

  return cache.get(key) as SphericalMercator
}
